import Link from "next/link";
import { cn } from "@/lib/utils";

export interface IndexEntry {
	num: string; // "01"
	label: React.ReactNode;
	href: string; // "#sobre-mi"
	hint?: string;
}

export function IndexList({
	entries,
	className,
}: {
	entries: IndexEntry[];
	className?: string;
}) {
	return (
		<nav aria-label="Índice" className={cn("border-t border-border", className)}>
			{entries.map((e) => (
				<Link
					key={e.href}
					href={e.href}
					className="group flex items-baseline justify-between gap-6 border-b border-border py-5 transition-colors hover:bg-cream/60"
				>
					<span className="font-display text-2xl sm:text-3xl text-ink">
						<span className="text-terracotta mr-3 text-lg">{e.num}</span>
						{e.label}
					</span>
					{e.hint && (
						<span className="font-body text-sm text-muted-foreground group-hover:text-terracotta">
							{e.hint} →
						</span>
					)}
				</Link>
			))}
		</nav>
	);
}
